import "./Recon.css";
import Pagination from "./Pagination";
import { useSelector } from "react-redux";
import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";

function ReconTable({
  dataItem,
  userData,
  setCurrentPage,
  currentPage,
  pagesData,
  startDate,
  endDate,
  getReconciliationData,
}) {
  const role = useSelector((store) => store.userReducer.role);

  const userMap = Object.fromEntries(
    (userData || []).map((user) => [user.id, user?.alias || user.id]),
  );

  const columns = [
    ...(role === "super" ||
    role === "operation" ||
    role === "compliance" ||
    role === "subSuper"
      ? [
          {
            header: "Business Name",
            accessor: "userId",
            render: (row) => userMap[row.userId] || "-",
          },
        ]
      : []),

    {
      header: "OrderId",
      accessor: "orderId",
      render: (row) => row.orderId || "-",
    },
    {
      header: "TransactionId",
      accessor: "transactionId",
      render: (row) => row.transactionId || "-",
    },
    {
      header: "Amount(₹)",
      accessor: "amount",
      render: (row) => Number(row.amount || 0).toFixed(2),
    },
    {
      header: "Transaction Date",
      accessor: "createdAt",
      render: (row) =>
        row.createdAt ? <DateCell date={row.createdAt} /> : "N/A",
    },
    {
      header: "Updated Date",
      accessor: "updatedAt",
      render: (row) =>
        row.updatedAt ? <DateCell date={row.updatedAt} /> : "N/A",
    },
    {
      header: "Penalty",
      accessor: "penalty",
      render: (row) => Number(row.penalty || 0).toFixed(2),
    },
    {
      header: "Status",
      accessor: "status",
      render: (row) => (
        <p className="table-user-data-report-1">
          {row.status === false ? "Pending" : "Completed"}
        </p>
      ),
    },
  ];

  return (
    <div className="table-main-report">
      <DataTable
        columns={columns}
        data={dataItem || []}
        emptyMessage="No chargeback data found."
      />

      {dataItem?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pagesData={pagesData}
          startDate={startDate}
          endDate={endDate}
          getReconciliationData={getReconciliationData}
        />
      )}
    </div>
  );
}

export default ReconTable;
